import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import SummerCampForm from "../molecules/SummerCampForm";
import { CloseIcon } from "../atoms/Icons";

export default function DrawerSummerCamp({ open, setOpen, translations }) {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="background-overlay fixed inset-0 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen 640:max-w-[736px]">
                  <div className="flex h-full flex-col overflow-y-scroll bg-gray-200 divide-y divide-mediumGray">
                    <div className="relative flex flex-col gap-y-40 min-h-0 flex-1 overflow-y-auto p-16 640:p-24">
                      <div className="min-h-50 flex flex-row justify-between items-center">
                        <span className="text-m 640:text-l leading-125 tracking-05 640:leading-120 640:tracking-00 font-medium">
                          Petrotec Summer Camp
                        </span>
                        <button
                          type="button"
                          className="fixed z-50 top-24 right-24 p-12 bg-gray-100 text-gray-900 border border-solid border-gray-300 media-hover:hover:bg-white rounded-xxxs duration-300"
                          onClick={() => setOpen(false)}
                          aria-label="Close"
                        >
                          <CloseIcon />
                        </button>
                      </div>
                      <div className="flex flex-col gap-y-40">
                        <SummerCampForm
                          setOpen={setOpen}
                          translations={translations}
                        />
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
